import Service from "./services";

export class ValuationService extends Service {

  getURLBase() {
    return 'p/valuation/';
  }

}